module.exports = __webpack_public_path__ + "img/metal_aq@2x.f3509e73.png";